// import store from '@/store/index.js'
export default [
  {
    path: '/signin',
    name: 'signin',
    component: require('@/views/auth/Signin.vue').default,
    meta: {
      requiresAuthentication: false
    }
  },
  // {
  //   path: '/obosignin/:oboToken',
  //   name: 'oboSignin',
  //   component: require('@/views/auth/OboSignin.vue').default,
  //   meta: {
  //     requiresAuthentication: false
  //   }
  // },
  {
    path: '/updatePassword',
    name: 'updatePassword',
    component: require('@/views/auth/UpdatePassword.vue').default,
    meta: {
      requiresAuthentication: true
    }
  },
  {
    path: '/',
    name: 'home',
    component: require('@/views/LandingView.vue').default,
    meta: {
      requiresAuthentication: true
    }
  },
  {
    path: '/search',
    name: 'search',
    component: require('@/views/Search.vue').default,
    meta: {
      requiresAuthentication: true
    }
  },
  {
    path: '/client/:clientId',
    component: require('@/views/clientViewer/Client/Client.vue').default,
    meta: {
      requiresAuthentication: true
    },
    children: [
      {
        path: '',
        name: 'clientLanding',
        component: require('@/components/Client/Landing.vue').default,
        meta: {
          requiresAuthentication: true
        }
      },
      {
        path: 'contacts',
        name: 'clientContacts',
        component: require('@/components/Client/ContactsWrapper.vue').default,
        meta: {
          requiresAuthentication: true
        }
      },
      {
        path: 'profiles',
        name: 'clientProfiles',
        component: require('@/components/Client/Profiles/ProfilesWrapper.vue').default,
        meta: {
          requiresAuthentication: true
        }
      },
      {
        path: 'policies',
        name: 'clientPolicies',
        component: require('@/components/Client/Policies/Policies.vue').default,
        meta: {
          requiresAuthentication: true
        }
      },
      {
        path: 'policy/:policyOrderNumber',
        name: 'clientPolicyDetail',
        component: require('@/views/clientViewer/Policy/Policy.vue').default,
        meta: {
          requiresAuthentication: true
        },
        children: [
          // Mono-line Policy Vehicle
          {
            path: 'vehicle/:vehicleId',
            name: 'policyVehicle',
            component: require('@/components/Client/LineOfBusiness/Vehicles/Vehicle/Vehicle.vue').default,
            meta: {
              requiresAuthentication: true
            }
          },
          // Mono-line Policy Drivers
          {
            path: 'driver/:driverId',
            name: 'policyDriver',
            component: require('@/components/Client/LineOfBusiness/Drivers/Driver/Driver.vue').default,
            meta: {
              requiresAuthentication: true
            }
          },
          // Package Policy Lob Info
          {
            path: 'lob/:lobId',
            component: require('@/views/clientViewer/LineOfBusiness/LineOfBusiness.vue').default,
            meta: {
              requiresAuthentication: true
            },
            children: [
              {
                path: '',
                name: 'lobLanding',
                component: require('@/components/Client/LineOfBusiness/Landing.vue').default,
                meta: {
                  requiresAuthentication: true
                }
              },
              {
                path: 'vehicle/:vehicleId',
                name: 'vehicle',
                component: require('@/components/Client/LineOfBusiness/Vehicles/Vehicle/Vehicle.vue').default,
                meta: {
                  requiresAuthentication: true
                }
              },
              {
                path: 'driver/:driverId',
                name: 'driver',
                component: require('@/components/Client/LineOfBusiness/Drivers/Driver/Driver.vue').default,
                meta: {
                  requiresAuthentication: true
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/clientLookup',
    name: 'clientLookup',
    component: require('@/views/LaunchClient.vue').default,
    meta: {
      requiresAuthentication: true
    }
  },
  {
    path: '/styleDemo',
    name: 'styleDemo',
    component: require('@/views/StyleDemo.vue').default,
    meta: {
      requiresAuthentication: true
    }
  },
  {
    path: '/unauthorized',
    name: 'unauthorized',
    component: require('@/views/auth/Unauthorized.vue').default,
    meta: {
      requiresAuthentication: false
    }
  }
];
